// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__oMLma {
    border-top: 1px solid #f2f2f2;
    padding: 5px 24px 5px 16px;
}

.iconContainer__CPWun {
    font-size: 20px;
}

.messageContainer__q5B12 {
    flex-grow: 1;
    padding: 0 20px;
}

.actionsContainer__d8S7q { }

.ctaButton__WYuCL {
    margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/MarketingBanner/styles.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA,2BAAoB;;AAEpB;IACI,iBAAiB;AACrB","sourcesContent":[".container {\n    border-top: 1px solid #f2f2f2;\n    padding: 5px 24px 5px 16px;\n}\n\n.iconContainer {\n    font-size: 20px;\n}\n\n.messageContainer {\n    flex-grow: 1;\n    padding: 0 20px;\n}\n\n.actionsContainer { }\n\n.ctaButton {\n    margin-right: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container__oMLma`,
	"iconContainer": `iconContainer__CPWun`,
	"messageContainer": `messageContainer__q5B12`,
	"actionsContainer": `actionsContainer__d8S7q`,
	"ctaButton": `ctaButton__WYuCL`
};
module.exports = ___CSS_LOADER_EXPORT___;
